<!-- <div class="page-container"> -->
<div class="d-flex m-0">
  <div class="col-lg-7 home-left-side"><app-information [buttonText]="'Log in'" (buttonClick)="buttonClickLogin()"></app-information></div>
  <div class="col-lg-5 no-padding home-right-side">
    <app-signup [onClickLogin]="ClickLogin"></app-signup>
  </div>
</div>
<!-- </div> -->
<app-query-params-ls></app-query-params-ls>
